/* global jQuery, require */
require( 'bootstrap.native/dist/polyfill' );

import Modal from 'bootstrap.native/dist/components/modal-native';
import isAdmin from '../../../helpers/isAdmin';

( ( $ ) => {
	const initializeBlock = ( $block ) => {
		if ( ! $block.length || isAdmin ) {
			return;
		}
        


		$( '[href^="#modal-"]' ).each( ( _index, element ) => {
			const href = $( element ).attr( 'href' );

			if ( ! $( `[data-idx="${ href }"]`, document ).length ) {
				return;
			}
            

			$( element ).on( 'click', ( event ) => {
				event.preventDefault();

				// fix for vimeo videos. When resolution is low, it tends to embed the iframe in low size.
				const modal = $( `[data-idx="${ href }"]` );
				if ( modal.find( '.is-provider-vimeo' ).length > 0 ) {
					if ( modal.find( 'iframe' ).attr( 'width' ) < 1000 ) {
						modal.find( 'iframe' ).attr( 'width', '1100' );
					}
					if ( modal.find( 'iframe' ).attr( 'height' ) < 600 ) {
						modal.find( 'iframe' ).attr( 'height', '619' );
					}
				}

				new Modal( `[data-idx="${ href }"]`, { keyboard: false } ).toggle();
                
                
			} );
            
            //OPEN MODAL FROM URL
            
            $( window ).on( 'load', ( event ) => {
            
            if (window.location.hash == href) {
                 event.preventDefault();

                 new Modal( `[data-idx="${ href }"]`, { keyboard: false } ).toggle();
                
             }
                
                else {
                    return;
                }
                
                } );
            
		} );
	};

	// Initialize each block on page load (front end).
	$( document ).ready( () => {
		$( '.modal' ).each( ( _index, element ) => {
			initializeBlock( $( element ) );
		} );
	} );

	// Initialize dynamic block preview (editor).
	if ( window.acf ) {
		window.acf.addAction(
			'render_block_preview/type=modal',
			initializeBlock
		);
	}
} )( jQuery );
